import React, { FunctionComponent } from 'react';

import { PostType } from '../../types';

import styles from './PostContent.module.scss';

export const PostContent: FunctionComponent<{ post: PostType }> = ({ post }) => {
  return (
    <article className={styles['faq__post-content']} data-tesid="post-content">
      <h1
        dangerouslySetInnerHTML={{ __html: post.title }}
        className={styles['faq__post-content_header']}
        data-testid="post-content-header"
      ></h1>
      {post.video && (
        <iframe
          src={post.video}
          width="100%"
          height="463"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles['faq__post-content_video']}
        />
      )}
      <div dangerouslySetInnerHTML={{ __html: post.content }} className={styles['faq__post-content_body']}></div>
    </article>
  );
};
